<template>
    <div class="filling-goods-div">
        <van-nav-bar title="计件" left-text="注销" left-arrow @click-left="onClickLeft()"></van-nav-bar>
        <span style="color: red" v-if="hostcs">测试服</span>
        <!-- 新增按钮 -->

        <button @click="scanQRCode" class="scan-button" v-if="!showBluetooth" style=" 
        margin-bottom: 10px; 
        font-size: 16px; 
        padding: 10px 20px; 
        background: linear-gradient(90deg, #2196F3, #42A5F5); 
        color: white; 
        border: none; 
        border-radius: 25px; 
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); 
        cursor: pointer; 
        transition: all 0.3s ease;">
            请点击扫一扫
        </button>


        <!-- Bluetooth Section -->
        <!-- <div v-if="showBluetooth" class="bluetooth">
            <div style="font-size: 14px;">请扫描工号: </div>
            <input id="bluetooth" class="bluetoothLink-input" @keyup.enter="gowork()" v-model="workid"
                ref="getIDInpot" />
        </div> -->
        <div v-if="showBluetooth" style="margin-top: 10px">
            当前工号为:{{ now_workerId }}
        </div>



        <!-- Current Selection Section -->
        <div v-else style="font-size: 14px; margin-top: 10px;">
            当前选择的工序/工人: {{ processName }}/{{ workerId }}
        </div>

        <!-- Dynamic Buttons -->
        <div class="bottom-section">
            <!-- Dynamic Buttons -->
            <div v-if="showButtons" class="dynamic-buttons"
                style="display: flex; flex-wrap: wrap; justify-content: center; gap: 10px; padding: 15px 10px">
                <van-button v-for="(url, key) in processData" :key="key" type="primary" class="process-button"
                    @click="handleButtonClick(url)"
                    style="flex: 1 0 calc(25% - 10px); margin-left: 10px;margin-top: 10px;max-width: calc(25% - 10px)">
                    {{ key }}
                </van-button>
            </div>
        </div>
        <!-- Scanning Input Section -->
        <div v-if="showScanningInput" style="margin-top: 20px;">
            <input id="scanDetailInput" class="scan-detail-input" placeholder="请扫描明细码" ref="scanInput"
                @keyup.enter="handleScanDetail(gck_number)" v-model="gck_number" />
        </div>

        <!-- Display Success Message -->
        <div v-if="successMsg" :style="{ marginTop: '20px', fontSize: '30px', color: isError ? 'red' : 'green' }">
            {{ successMsg }}
        </div>

        <!-- Bottom Buttons -->
        <div class="filling-goods-bottom" style="display: flex">
            <van-button type="primary" class="bottom-button" @click="reloads()">刷新</van-button>
            <van-button type="warning" class="bottom-button" @click="go_index()">回首页</van-button>
            <van-button type="info" class="bottom-button" @click="print_again()">再次打印</van-button>
            <!-- <van-button type="info" class="bottom-button-b" @click="goLink()">发送蓝牙地址</van-button> -->
        </div>
        <div style="height: 600px; overflow: auto;color: #000;" v-if="show_print">
            <div class="wh"
                :style="{ width: S_width + 'cm', height: 15 + 'cm', marginTop: S_top + 'cm', padding: '5px', display: flex }"
                v-for="(i, index) in washData" :key="index" style="page-break-inside: avoid;">
                <!-- 非城市素颜使用 -->
                <div style="display: flex;justify-content: center;">
                    <!-- 左侧数据 -->
                    <div style="width: 5cm;position: relative; text-align: left;" id="popupPrint">
                        <div style="font-size: 13px;margin: 3px 0;padding-left:0px;padding-bottom: 15px;">
                            <span
                                style="font-size: 13px;display:inline-block;width: 100%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;vertical-align:top;font-weight: bold;">
                                {{ i.print_time }}</span>
                        </div>
                        <div style="font-size: 16px!important;margin: 3px 0;padding-left:0px;">
                            <span
                                style="font-size: 16px;display:inline-block;width: 100%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;vertical-align:top;font-weight: bold;">
                                货号:{{ (i.name) }}</span>
                        </div>
                        <div style="margin: 3px 0;padding-left:0px;" :style="{ fontSize: '16px' }">
                            <span :style="{ fontSize: '16px' }"
                                style="display: inline-block; width: auto; vertical-align: top; overflow: visible; white-space: nowrap;font-weight: bold;">
                                颜色:{{ (i.rd_color) }}【{{ i.channel }}】</span>
                        </div>
                        <div style="font-size: 24px!important;margin: 3px 0;padding-left:0px;">
                            <span
                                style="display:inline-block;font-size: 24px;width: 65%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;vertical-align:top;font-weight: bold;">
                                宽:{{ (i.cpcm) }}</span>
                        </div>
                        <div style="font-size: 24px!important;margin: 3px 0;padding-left:0px;">
                            <span
                                style="display:inline-block;font-size: 24px;width: 65%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;vertical-align:top;font-weight: bold;">
                                高:{{ (i.cpgd) }}</span>
                        </div>
                        <div style="font-size: 20px;margin: 3px 0;padding-left:0px;">
                            <span
                                style="font-size: 20px;display:inline-block;width: 65%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;vertical-align:top;font-weight: bold;">
                                款式:{{ (i.cpks) }}</span>
                        </div>

                        <div style="font-size: 14px;margin: 3px 0;padding-left:0px;">
                            <span
                                style="font-size: 14px;display:inline-block;width: 65%;white-space: nowrap;text-overflow: ellipsis;vertical-align:top;font-weight: bold;">
                                备注:{{ i.mx_remark[0] }}</span>
                        </div>
                        <div style="font-size: 14px;margin: 3px 0;padding-left:0px;">
                            <span
                                style="font-size: 14px;display:inline-block;width: 65%;white-space: nowrap;text-overflow: ellipsis;vertical-align:top;font-weight: bold;">
                                {{ i.mx_remark[1] || '&nbsp;' }}</span>
                        </div>
                        <div style="font-size: 16px;margin: 3px 0;padding-left:0px;" v-if="i.enterprises_tech === '定型'">
                            <span
                                style="font-size: 16px;display:inline-block;width: 65%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;vertical-align:top;font-weight: bold;">
                                定型:{{ (i.enterprises_tech ? "高温定型" : "") }}</span>
                        </div>
                        <div style="font-size: 16px;margin: 3px 0;padding-left:0px;">
                            <span
                                style="font-size: 16px;display:inline-block;width: 65%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;vertical-align:top;font-weight: bold;">
                                {{ i.order_time }}【{{ i.goods_count }}】</span>
                        </div>
                        <!-- qrcode去生成 -->
                        <!-- <Barcode :JsBarcodeData="JsBarcodeConfigData"
                            style="width: 150px; height: 100px; margin: 0; padding-left: 15px;" /> -->
                        <div style="text-align: left;margin: 3px 0;padding-right: 0px;">
                            <img :src="i.qrCodeData" alt="QR Code" style="width: 60px;height: 60px">
                        </div>
                        <div style="font-size: 16px;margin: 0px 0;padding-left:0px;text-align: left;">
                            <span
                                style="font-size: 16px;display:inline-block;width: 65%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;vertical-align:top;font-weight: bold;">
                                {{ i.gck_number }}</span>
                        </div>
                        <div style="font-size: 16px;margin: 0px 0;padding-left: 0px;margin-bottom: 20px;">
                            <span
                                style="font-size: 16px;display:inline-block;width: 65%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;vertical-align:top;font-weight: bold;">
                                [{{ i.number_count }}]</span>
                        </div>

                    </div>

                </div>


            </div>
        </div>



    </div>


</template>

<script>
import $ from "jquery";
import axios from 'axios';
import { mapState, mapMutations } from "vuex";
import { Dialog } from "vant";
import { Toast } from "vant";
import html2canvas from 'html2canvas';
import moment from 'moment';
import Barcode from '@/components/Barcode';
import QRCode from 'qrcode-generator';
export default {
    name: "bluetoothLink",
    data() {
        return {
            hostcs: false,
            more_show: false,
            ray: "扫描中",
            id: "",
            username: "",
            lasttime: '',
            processData: {}, // 动态生成的工序数据
            workid: "", // 工号
            processName: "", // 工序名称（从 URL 中解析）
            workerId: "", // 工人 ID
            showBluetooth: true, // 是否显示 Bluetooth 输入框
            showButtons: true, // 是否显示动态按钮
            showScanningInput: false, // 是否显示扫描明细码输入框
            successMsg: "", // 用于展示请求成功后的消息
            show_print: false,
            JsBarcodeConfigData: {
                text: '', // 条形码必须是字符串类型，否则会出现后面几位为数字的情况。
                lineColor: "#000000", //二维码颜色
                background: "#fff", //二维码背景色
                //width: this.widthStyleObj, 
                bottomtext: '',
            },
            washData: [],
            gck_number: '',
            now_workerId: '',
            audio: new Audio(require("@/assets/ww.mp3")),
            isError: false,
            print_gck: '',
        };
    },
    components: {
        Barcode
    },
    mounted() {
        this.workid = JSON.parse(window.localStorage.getItem("userinfo"));
        window.receiveDataFromAndroid = this.receiveDataFromAndroid;
        window.receiveDataFromAndroids = this.receiveDataFromAndroids;
        this.username = JSON.parse(window.localStorage.getItem("userinfo"));
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.style =
            "text-align: left;width: 100%;height: " + h * 0.66 + "px;overflow:scroll";
        // setTimeout(() => {
        //     this.focus();
        // }, 500);
        if (window.location.host.indexOf("cspda") !== -1) {
            this.hostcs = true;
        }
        this.gowork();

    },
    methods: {
        focus() {
            this.$refs.getIDInpot.focus();
        },
        gowork() {
            this.now_workerId = this.workid;
            this.get("/processFindAndroid", { number: this.workid }).then(
                (res) => {
                    if (res.data != "") {

                        // 调用解析方法，保证逻辑与安卓一致
                        this.parseProcessData(JSON.stringify(res.data));
                    } else {
                        // 提示用户检查工号
                        this.showToast('请检查工号是否有误！');
                    }

                }
            ).catch((error) => {
                // 捕获请求错误
                console.error('请求失败:', error);
            });;
        },
        parseProcessData(responseData) {
            try {
                const jsonObject = JSON.parse(responseData);
                const status = jsonObject.status;
                const msg = jsonObject.msg;
                if (status === 0) {
                    Toast(msg); // 显示提示信息
                    this.workid = ""; // 清空输入框
                    this.processData = {}; // 清空按钮数据
                    return;
                }
                const data = jsonObject.data;
                this.processData = {}; // 清空之前的数据
                for (const key in data) {
                    if (data.hasOwnProperty(key)) {
                        const process = data[key];
                        const url = process.url;
                        this.processData[key] = url; // 存储动态按钮数据
                    }
                }
            } catch (e) {
                console.error("数据解析失败", e);
            }
        },
        // 动态按钮点击事件
        async handleButtonClick(url) {
            if (url.startsWith("http://")) {
                url = url.replace("http://", "http://");
            }
            this.urlsend = url;
            // 从 URL 中解析工序名称（假设 URL 格式为：...process=工序名）
            const processMatch = url.match(/process=([^&]*)/);
            this.processName = processMatch ? processMatch[1] : "未知工序";
            if (!this.workerId) {
                this.workerId = this.workid; // 将工号赋值给 workerId
            }
            // 隐藏 Bluetooth 和按钮，显示扫描明细框
            this.showBluetooth = false;
            this.showButtons = false;
            this.showScanningInput = true;
            Android.sendghandgr(this.processName + "," + this.workerId);
            this.focusInput("scanInput");
            console.log("当前选工序：", this.processName);
            console.log("当前选工人：", this.workerId);
        },
        async handleScanDetail(ids) {
            this.print_gck = "";
            this.print_gck = ids;
            this.isError = false;
            const completeUrl = `${this.urlsend}${ids}`; // 拼接 URL
            try {
                const res = await axios.get(completeUrl);
                console.log(res);
                if (res.data && res.data.data && res.data.data.data && (res.data.data.data.status == 1 || res.data.data.data.status == "OK")) {
                    if (this.processName == "包装") {
                        this.successMsg = res.data.msg;
                        const result = await this.getwash(ids);
                        if (result === null) {
                            return;
                        }
                        // console.log("aaaa")
                        this.dayin();
                    } else {
                        this.successMsg = res.data.msg;
                        this.gck_number = ""

                    }

                    this.focusInput("scanInput"); // 再次聚焦到详细码输入框
                } else {
                    // 显示错误提示
                    this.isError = true; // 新增一个标志变量，表示当前是否为错误情况
                    this.audio.play();
                    this.gck_number = ""
                    this.successMsg = res.data.msg;
                    this.focusInput("scanInput"); // 再次聚焦到详细码输入框
                }
            } catch (error) {
                // 捕获请求错误
                this.audio.play();
                this.gck_number = ""
                this.focusInput("scanInput"); // 再次聚焦到详细码输入框
                console.error("请求失败：", error);
                Toast("请求异常，请稍后重试！");
            }
        },
        go_index() {
            Dialog.confirm({
                message: "确定要回首页吗？",
            })
                .then(() => {
                    this.$router.push("/home");
                })
                .catch(() => {
                    // on cancel
                });
        },
        async dayin() {
            this.show_print = true;
            await this.$nextTick();
            // 等待html2canvas渲染完成
            const canvas = await html2canvas(document.querySelector("#popupPrint"));

            var imageBase64 = canvas.toDataURL(); // 将imageData作为参数传递给callAndroid()方法
            imageBase64 = imageBase64.replace(/^data:image\/\w+;base64,/, '');
            console.log(imageBase64);
            this.gck_number = ""
            // 调用callAndroid
            this.callAndroid(imageBase64);
        },
        // dayin() {
        //     this.JsBarcodeConfigData.text = "123123";
        //     this.JsBarcodeConfigData.bottomtext = "123123";
        //     this.show_print = true;

        //     html2canvas(document.querySelector("#popupPrint")).then((canvas) => {
        //         //document.body.appendChild(canvas);
        //         var imageBase64 = canvas.toDataURL();// 将imageData作为参数传递给callAndroid()方法
        //         var imageBase64 = imageBase64.replace(/^data:image\/\w+;base64,/, '');
        //         console.log(imageBase64);
        //         this.callAndroid(imageBase64);
        //     });
        // },
        callAndroid(imageBase64) {
            var BASE64_ENCODED_IMAGE_DATA = imageBase64;
            var imageData = BASE64_ENCODED_IMAGE_DATA;
            console.log(imageData);
            this.show_print = false;
            Android.receiveImage(imageData);
            alert("printPreview");
        },
        focusInput(refName) {
            this.$nextTick(() => {
                const input = this.$refs[refName];
                if (input) {
                    input.focus();
                }
            });
        },
        // async receiveDataFromAndroid(data) {
        //     this.now_workerId = "";
        //     if (data) {
        //         this.now_workerId = data;
        //         this.workerId = data;
        //         this.get("/processFindAndroid", { number: data }).then(
        //             (res) => {
        //                 if (res.data != "") {
        //                     // 调用解析方法，保证逻辑与安卓一致
        //                     this.parseProcessData(JSON.stringify(res.data));
        //                 } else {
        //                     // 提示用户检查工号
        //                     this.showToast('请检查工号是否有误！');
        //                 }

        //             }
        //         ).catch((error) => {
        //             // 捕获请求错误
        //             console.error('请求失败:', error);
        //         });;
        //     }
        // },
        receiveDataFromAndroids(data) {
            if (data) {
                if (this.showBluetooth) {
                    this.workid = data;
                    this.gowork()
                } else {
                    this.gck_number = data;
                    this.handleScanDetail(data);
                }
            }
        },
        async getwash(val) {
            // 使用 fetch 发起 GET 请求
            try {
                this.time = '';
                let current_time = this.getCurrentDateTime();
                this.washData = [];
                const url = `http://admintm.runfeinet.com/admin/orderMxDyAll?id=${val}`;
                const responseData = await fetch(url);
                const wash = await responseData.json();
                if (wash.status == 1) {
                    wash.data.forEach((item, index) => {
                        const washData = {};
                        washData.flag = (item.order_number.indexOf('ylst') && item.order_number.indexOf('aml')) === -1 ? true : false;
                        washData.jt_xh = item.sis['型号'] ? item.sis['型号'] : (this.xh ? this.noramal(xh) : (item.ppxh ? this.noramal(item.ppxh) : this.noramal(item.xh)))
                        if (item.goods_count == 1) {
                            // 检查 item.gck_number 是否包含 "-"
                            if (!item.gck_number.includes('-')) {
                                // 如果不包含 "-", 则将其修改为 item.gck_number + '-'
                                this.JsBarcodeConfigData.text = item.gck_number + '-1';
                                this.JsBarcodeConfigData.bottomtext = item.gck_number + '-1';

                            } else {
                                this.JsBarcodeConfigData.text = item.gck_number;
                                this.JsBarcodeConfigData.bottomtext = item.gck_number;
                            }
                        } else {
                            this.JsBarcodeConfigData.text = item.gck_number;
                            this.JsBarcodeConfigData.bottomtext = item.gck_number;
                        }
                        const qr = QRCode(0, 'H');
                        qr.addData(this.JsBarcodeConfigData.text);
                        qr.make();
                        const imageDataURL = qr.createDataURL(10, 0);
                        washData.qrCodeData = imageDataURL;
                        washData.print_time = current_time;
                        washData.goods_id = item.goods_id;
                        washData.enterprises_tech = item.enterprises_tech;
                        washData.rd_color = item.rd_color;
                        washData.channel = item.channel ? item.channel[0] : '';
                        washData.ppxh = item.ppxh;
                        washData.dyyz = item.dyyz;
                        washData.dymd = item.dymd;
                        washData.goods = item.goods_new;
                        washData.warehouse = item.warehouse;
                        washData.address = item.address;
                        washData.color = item.color;
                        // 假设 item.mx_remark 是字符串
                        washData.mx_remark = [];
                        let remark = item.mx_remark || ""; // 确保 remark 不为 null 或 undefined
                        // 分割字符串
                        washData.mx_remark[0] = remark.substring(0, 6); // 取前6个字符
                        washData.mx_remark[1] = remark.substring(6);   // 取剩余的字符
                        washData.wash = item.wash;
                        washData.webname = item.webname;
                        washData.order_time = this.datetimes(item.order_time);
                        washData.logo = item.logo;
                        washData.belong = item.belong;
                        washData.goods_id = item.goods_id;
                        washData.people = item.people;
                        washData.ppbz = item.ppbz;
                        washData.hp = item.hp;
                        washData.xlh = item.xlh;
                        washData.goods_count = item.goods_count;
                        washData.kd_status = item.kd_status;
                        // washData.name = item.name;
                        if (item.name.indexOf('-') !== -1) {
                            washData.name = item.name.split('-')[0];
                        } else {
                            washData.name = item.name;
                        }
                        washData.fx = item.fx;
                        washData.ks = item.ks;
                        washData.mst = item.mst;
                        washData.mk = item.mk;
                        washData.xh = item.xh;
                        washData.gg = item.gg;
                        washData.lg = item.lg;
                        washData.cm = item.cm;
                        // 检查 item.count 是否为 1
                        if (item.goods_count == 1) {
                            // 检查 item.gck_number 是否包含 "-"
                            if (!item.gck_number.includes('-')) {
                                // 如果不包含 "-", 则将其修改为 item.gck_number + '-'
                                washData.gck_number = item.gck_number + '-1';
                            } else {
                                washData.gck_number = item.gck_number;
                            }
                        } else {
                            washData.gck_number = item.gck_number;
                        }
                        washData.fc = item.fc;
                        washData.order_number = item.order_number;
                        washData.dm = item.dm;
                        washData.khfx = item.sis.开合方向;
                        washData.cpks = item.sis.成品款式;
                        washData.chkd = item.sis.宽度;
                        washData.cpcm = item.sis.宽度;
                        washData.cpgd = item.sis.高度;
                        washData.fjmc = item.sis.房间名称;
                        washData.count = item.count;
                        washData.number_count = item.number_count;
                        this.washData.push(washData);
                    })
                } else {
                    this.$message({
                        type: 'error',
                        message: '打印接口错误！',
                    })
                    this.gck_number = "";
                    this.print_gck = "";
                }
            } catch (error) {
                console.log(error)
                Toast("打印请求异常，请稍后重试！");
                this.print_gck = "";
                this.gck_number = "";
                return null; // 或者返回其他默认值
            }
        },
        getCurrentDateTime() {
            const now = new Date();

            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1，并补零
            const day = String(now.getDate()).padStart(2, '0'); // 补零
            const hours = String(now.getHours()).padStart(2, '0'); // 补零
            const minutes = String(now.getMinutes()).padStart(2, '0'); // 补零
            const seconds = String(now.getSeconds()).padStart(2, '0'); // 补零

            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
        noramal(value) {
            if (value == null || value == undefined) {
                return ''
            } else {
                return value
            }
        },
        datetimes(times) {
            // 原始日期字符串
            const dateTime = times;

            // 使用 split 方法分割日期和时间
            const datePart = dateTime.split(' ')[0]; // "2024-11-05"

            // 将日期部分再分割为年、月、日
            const dateComponents = datePart.split('-'); // ["2024", "11", "05"]

            // 提取需要的部分，拼接成目标字符串
            const result = dateComponents[0].slice(2) + dateComponents[1] + dateComponents[2]; // "241105"
            return result
        },
        scanQRCode() {
            Android.scarn();
        },
        onClickLeft() {
            localStorage.removeItem("checked_auto");
            localStorage.removeItem("userinfo");
            this.$router.push("/");
        },
        async print_again() {
            if (this.processName == "包装") {
                if (!this.print_gck) {
                    Toast("请先扫描明细码");
                }
                const result = await this.getwash(this.print_gck);
                if (result === null) {
                    return;
                }
                this.dayin();
            } else {
                Toast("请选择定型工序后打印");
            }
        },
        reloads() {
            window.location.reload();
        },

    },
};
</script>

<style lang="less">
@import "../style/outOrderInfo.less";

.bluetooth {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 100%;
    margin-top: 50px;
}

.bluetoothLink-input {
    height: 22px;
    width: 4rem;
    width: 70%;
}

.bottom-button-b {
    width: auto;
}
</style>